<div
  class="bg-[#A0937D] h-[60px] lg:h-[50px] flex justify-between items-center text-white relative overflow-hidden flex-shrink-0 cursor-pointer lg:cursor-default px-4 shadow-md z-10"
  (click)="isMobileCartExpanded.set(!isMobileCartExpanded())">
  <!-- <div class="flex items-center gap-3">
    <h2 class="fs-16 font-bold tracking-widest pl-2">{{ 'ORDERSTR0001' | translate }}</h2>
  </div> -->
  @if (!isMobileCartExpanded()) {
  <div class="lg:hidden flex items-center gap-3 ml-auto"><span class="font-bold">{{ total() | currency:'':'':'1.0-0' }}
      {{'USERMAG0048'| translate}}</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round">
      <path d="m18 15-6-6-6 6" />
    </svg></div>
  }
  <div class="hidden lg:block absolute right-3 top-1/2 -translate-y-1/2">
    <div class="flex gap-4">
      @if(viewMode() !== 'payment'){
      @if(paymentReservation() === true){
      <button (click)="onCancelPaymentReservation()"
        class="bg-[#4A4442] hover:bg-black/30 text-[11px] px-3 py-1.5 rounded text-white transition-all font-bold text-center leading-tight border border-white/20 shadow-sm flex flex-col items-center justify-center h-10 w-[80px] 2xl:w-[100px]">
        <div class="text-gray-300 text-[14px] text-ellipsis">{{'SYSMESER0010' | translate}}
        </div>
      </button>
      }
      }
      @if(viewMode() !== 'payment'){
      <button (click)="onRemoveAllCart()"
        class="bg-[#4A4442] hover:bg-black/30 text-[11px] px-3 py-1.5 rounded text-white transition-all font-bold text-center leading-tight border border-white/20 shadow-sm flex flex-col items-center justify-center h-10 w-[80px] 2xl:w-[100px]">
        <div class="text-gray-300 text-[14px] text-ellipsis">{{'STOREHQ0003' | translate}}
        </div>
      </button>
      }
      <button (click)="toggle($event)"
        class="bg-[#4A4442] hover:bg-black/30 text-[11px] px-3 py-1.5 rounded text-white transition-all font-bold text-center leading-tight border border-white/20 shadow-sm flex flex-col items-center justify-center h-10 w-[80px] 2xl:w-[100px]">
        <div class="text-gray-300 text-[14px] text-ellipsis">{{ selectedmember ? selectedmember : 'ORDERSTR0002' |
          translate }}
        </div>
      </button>
    </div>
  </div>
</div>
<div class="flex-1 overflow-y-auto p-3 bg-white space-y-2 min-h-0">
  @if(cart().length === 0) {
  <div class="h-full flex flex-col items-center justify-center text-center p-8">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="mb-4 opacity-50">
      <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
      <path d="M3 6h18" />
      <path d="M16 10a4 4 0 0 1-8 0" />
    </svg>
    <!-- <p class="font-semibold fs-14">{{ 'cart.empty' | translate }}</p>
    <p class="fs-14">{{ 'cart.emptySub' | translate }}</p> -->
  </div>
  } @else {
  @for (item of cart(); track item.servicE_CD; let i = $index) {
  <div class="flex p-2 rounded-xl border items-center gap-3 relative transition-all"
    [class.bg-[#EBF5FF]]="i === cart().length - 1 && viewMode() !== 'payment'"
    [class.border-blue-300]="i === cart().length - 1 && viewMode() !== 'payment'"
    [class.shadow-sm]="i === cart().length - 1 && viewMode() !== 'payment'"
    [class.bg-[#F5F5F5]]="i !== cart().length - 1 || viewMode() === 'payment'"
    [class.border-gray-200]="i !== cart().length - 1 || viewMode() === 'payment'">
    <div class="flex-1 min-w-0">
      <div class="fs-14 leading-tight truncate pr-6">{{ item.l_ClassName }}</div>
      <div class="fs-14  mt-0.5">{{ item.s_ClassName }}</div>
      <div class=" fs-14 mt-0.5">{{ item.servicE_NM }}</div>
    </div>
    @if(viewMode() === 'payment'){
    <div class="flex flex-col items-end gap-2 pr-10">
      <div class="flex items-center px-1 py-0.5 h-8">
        <span class="w-8 text-center font-bold text-red-500 fs-14">{{ item.quantity }}</span>
      </div>
      <div class="text-right font-bold fs-14">{{ (item.price * item.quantity) | currency:'':'':'1.0-0'
        }} <span class="fs-14 font-normal">{{'USERMAG0048'| translate}}</span></div>
    </div>
    }
    @else {
    <div class="flex flex-col items-end gap-2 pr-16">
      <div class="flex items-center bg-white border border-gray-300 rounded-full px-1 py-0.5 shadow-sm h-8">
        <button (click)="onUpdateQuantity(item, -1)" [disabled]="viewMode() === 'payment'"
          class="w-7 h-full flex items-center justify-center  hover:bg-gray-100 rounded-full transition-colors"><svg
            xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14" />
          </svg>
        </button>
        <div class="cart-qty">
          <p-inputnumber inputId="integeronly" [min]="0" [max]="99" [(ngModel)]="item.quantity"
            (ngModelChange)="onUpdateQtyInqut(item, $event)" styleClass="w-14 text-red-500 h-[20px] border-none"
            inputStyleClass="border-none h-full fs-14 w-full text-center" />
        </div>
        <!-- <span class="w-8 text-center font-bold text-red-500 fs-14">{{ item.quantity }}</span> -->
        <button (click)="onUpdateQuantity(item, 1)" [disabled]="viewMode() ==='payment'"
          [class]="item.quantity < 99 ? 'opacity-1' : 'opacity-0 pointer-events-none'"
          class="w-7 h-full flex items-center justify-center  hover:bg-gray-100 rounded-full transition-colors"><svg
            xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </button>
      </div>
      <div class="text-right font-bold fs-14">{{ (item.price * item.quantity) | currency:'':'':'1.0-0'
        }} <span class="fs-14 font-normal ">{{'USERMAG0048'| translate}}</span></div>
    </div>
    <button (click)="onRemoveFromCart(item)" [disabled]="viewMode() === 'payment'"
      class="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-gray-100  hover:bg-red-500 hover:text-white rounded-lg transition-all shadow-sm"><svg
        xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 6h18" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      </svg></button>
    }
  </div>
  }
  }
</div>
<div class="z-20 flex-shrink-0 bg-[#3E3937] shadow-inner">
  @if (viewMode() === 'register') {
  <div class="bg-[#707070] text-white">
    <div class="border-b border-gray-600 divide-y divide-gray-600 fs-14">
      <div class="flex justify-between items-center px-6 py-3"><span class="text-gray-300 font-bold">{{
          'PAYMESTR0033' | translate }}</span><span class="fs-14 font-bold">{{ totalQuantity() | number}} {{
          'ORDERSTR0011' |
          translate}}</span></div>
      <div class="flex justify-between items-center px-6 py-3"><span class="text-gray-300 font-bold">{{
          'ORDERSTR0012' | translate }}</span><span class="fs-14 font-bold">{{DISCOUNT_AMT() | number}} {{ 'USERMAG0048'
          | translate}}</span>
      </div>
      <div class="flex justify-between items-center px-6 py-3"><span class="text-gray-300 font-bold">{{
          'ORDERSTR0013' | translate }}</span><span class="fs-14 font-bold">{{ total() | currency:'':'':'1.0-0'
          }} {{ 'USERMAG0048' | translate}}</span></div>

    </div>
  </div>
  <button (click)="onGoToPayment()" [disabled]="cart().length === 0"
    class="w-full fs-26 bg-[#3E3937] hover:bg-[#2d2928] disabled:bg-gray-500 disabled:cursor-not-allowed text-white  font-bold py-6 border-t border-gray-600 transition-all active:bg-[#222]">{{
    'ORDERSTR0005' | translate }}</button>
  } @else {
  <div class="bg-[#3E3937] text-white">
    <div class="border-b border-gray-600 divide-y divide-gray-600 fs-14">
      <div class="flex justify-between items-center px-6 py-3"><span class="text-gray-300 font-bold">{{
          'PAYMESTR0033' | translate }}</span><span class="fs-14 font-bold">{{ totalQuantity() | number}} {{
          'ORDERSTR0011' | translate}}</span></div>
      <div class="flex justify-between items-center px-6 py-3"><span class="text-gray-300 font-bold">{{
          'PAYMESTR0034' | translate }}</span><span class="fs-14 font-bold">{{ total() | number
          }} {{ 'USERMAG0048' | translate}}</span></div>
      <div class="flex justify-between items-center px-6 py-3"><span class="text-gray-300 font-bold">{{
          'PAYMESTR0035' | translate }}</span><span class="fs-14 font-bold">{{DISCOUNT_AMT() | number}} {{ 'USERMAG0048'
          | translate}}</span>
      </div>
      <div class="flex justify-between items-center px-6 py-4"><span class="text-white font-bold">{{
          'PAYMESTR0036' | translate }}</span><span class="fs-26 font-bold">{{ totalPayment() |
          number }} {{ 'USERMAG0048' | translate}}</span></div>
    </div>
  </div>
  }
</div>


@if (openUserSearch()) {
<div class="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm"></div>
<div class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="flex justify-between border-b">
      <h1 class="p-3 fw-600">{{'ORDERSTR0002' | translate}}</h1>
      <button class="p-3 fw-600" (click)="onClose()"><i class="pi pi-times"></i></button>
    </div>

    <div class="w-full p-6 md:p-8 flex flex-col gap-3">
      <div class="flex justify-center">
        <div class="grid grid-cols-2 gap-2">
          <label class="flex items-center">{{'PAYMESTR0061' | translate}}</label>
          <input type="text" class="input-text h-[40px] w-full md:w-56 fs-14" disabled [value]="selectedmember">
        </div>
      </div>

      <div class="flex justify-center">
        <div class="grid grid-cols-2 gap-2">
          <label class="flex items-center">{{'PAYMESTR0062' | translate}}</label>
          <div>
            <p-select [(ngModel)]="selectedStaff" (onChange)="onChangeSelectStaff()" [placeholder]="'PAYMESTR0062' | translate" [options]="userList"
              optionLabel="useR_NM" class="w-full md:w-56" appendTo="body" />
            @if(isErrorSaveStaff){
            <div>
              <p class="text-danger text-red-500 fs-12">{{'PAYMESTR0065' | translate}}</p>
            </div>
            }

          </div>
        </div>
      </div>

      <div class="mt-8 flex justify-end gap-4">
        <button (click)="selectMember()"
          class="px-6 py-3 bg-gray-700 text-gray-100 font-bold rounded-lg hover:bg-gray-500 transition-colors">
          {{ 'INVOIDHQ0003' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}